import { inject } from "@angular/core";
import { UrlTree, Router, ActivatedRouteSnapshot } from "@angular/router";
import { firstValueFrom } from "rxjs";
import { PiaContextService } from "../../shared/pia-api/pia-context.service";
import { PiaLocaleService } from "../../shared/services/pia-locale.service";

export async function defaultCountryProductInfoRedirect(
  redirectData: Pick<ActivatedRouteSnapshot, "url">,
): Promise<UrlTree> {
  const contextService = inject(PiaContextService);
  const router = inject(Router);
  const piaLocale = inject(PiaLocaleService);

  // The country comes from the URL, the language from the profile selection —
  // PIA falls back to its own first language if the profile one is not offered
  // for that country.
  const countryID = redirectData.url[1].path;
  const languageID = await firstValueFrom(
    contextService.getDefaultLanguageIdByCountryId({
      countryID,
      preferredLanguageID: piaLocale.language,
    }),
  );

  if (!languageID) {
    return router.createUrlTree(["pia", countryID, "not-found"]);
  }

  const latestYear = await firstValueFrom(
    contextService.getLatestYearByCountryIdAndLanguageId({
      countryID,
      languageID,
    }),
  );
  return router.createUrlTree([
    "pia",
    countryID,
    languageID,
    latestYear,
    "product-info",
  ]);
}
